module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Produccion Musical RO.078928de.png";